import SelectLocker from './SelectLocker';

export default SelectLocker;
